import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { UserCentricsBrowserService } from './services/user-centrics.browser.service';
import { UserCentricsServerService } from './services/user-centrics.server.service';
import { UserCentricsService } from './services/user-centrics.service';

export function provideUserCentrics(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: UserCentricsService, useClass: UserCentricsBrowserService }]);
}

export function provideUserCentricsServer(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: UserCentricsService, useClass: UserCentricsServerService }]);
}
